import { Box, Button, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Screen from '../../components/fragments/Screen';

export default function DebugScreen() {
    const [registration, setRegistration] = useState(undefined);
    const state = useSelector((st) => st);

    useEffect(() => {
        setRegistration(navigator.serviceWorker.getRegistration());
    }, []);

    const sendNotification = async () => {
        if (Notification.permission === 'granted') {
            showNotification('Hello World');
        } else {
            if (Notification.permission !== 'denied') {
                const permission = await Notification.requestPermission();
                if (permission === 'granted') {
                    showNotification('Hello World');
                }
            }
        }
    };

    const showNotification = (body) => {
        if ('showNotification' in registration) {
            registration.showNotification('What PWA Can Do Today', { body });
        } else {
            new Notification('What PWA Can Do Today', { body });
        }
    };

    return (
        <Screen title="Debug">
            <Grid item xs={12}>
                <Box
                    style={{
                        display: 'block',
                        padding: 10,
                        margin: 10,
                        color: 'grey.300',
                        border: '1px solid',
                        borderColor: 'grey.300',
                        borderRadius: 2,
                        fontSize: '0.875rem',
                        fontWeight: '700',
                        wordWrap: 'break-word',
                        whiteSpace: 'pre-wrap',
                    }}
                >
                    {state.auth?.fcm}
                </Box>
                <Button variant="outlined" onClick={sendNotification}>
                    Trigger
                </Button>
            </Grid>
        </Screen>
    );
}
